import { userConstants } from './../constants/user.constants';

const initialState = {};

export function Getaadharfront(state = initialState, action) {
  
  //
  switch (action.type) {
    case userConstants.GETAADHARFRONT_REQUEST:
      return {
        user: action.user,
        isLoading : true

      };
    case userConstants.GETAADHARFRONT_SUCCESS:
      const {res} = action
        
      return {
        res,
        isLoading : false
      };
    case userConstants.GETAADHARFRONT_FAILURE:
      return {
        isLoading : false
      };
    default:
      return state
  }
}